<!-- La classe theme-default est portée par <body> (cf. index.html). -->
@if (!loading) {
    @if (isConnected && config) {
        <i-navbar [config]="config" (langChange)="onLangChange($event)">
            <router-outlet></router-outlet>
        </i-navbar>
    } @else {
        <router-outlet></router-outlet>
    }
} @else {
    <div class="loader-full">
        <i-loader [styleClass]="'full'"></i-loader>
    </div>
}

<p-toast [key]="'iValidation'" [position]="'bottom-right'"/>
